<div class="community mb-3">
  <div class="d-flex w-100 flex-column">
    <h2>All Services</h2>

    <div class="tabs-filter mt-3">
      <div class="button" (click)="loadProducts()" [class.active]="selectedTab === 'popular'">
        <div>
          <i class="fas fa-fire me-1"></i>
          Popular
        </div>
      </div>
      <div class="button" (click)="loadProducts('latest')" [class.active]="selectedTab === 'latest'">
        <div>
          <i class="fas fa-clock me-1"></i>
          Latest
        </div>
      </div>
      <div class="button" (click)="loadProducts('friends')" [class.active]="selectedTab === 'friends'">
        <div>
          <i class="fas fa-users me-1"></i>
          Friends
        </div>
      </div>
    </div>
  </div>

  <div class="tabs mt-3" style="position: relative;">
    <ng-container *ngIf="areThereMore as more">
      <div *ngIf="more"
        style="color: var(--secondary); position: absolute; right: 3%; bottom: 50%; z-index: 1000; font-weight: bold; font-size: 1.6rem">
        <svg width="24" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5l7 7-7 7" stroke="#b32596" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </ng-container>

    <ng-container *ngIf="showtCarousel as showCarousel">
      <app-my-carousel-swiper *ngIf="showCarousel" [navigation]="false" (onSwiper)="onProductsSwiper($event)"
        (onSlideChange)="onProductSlideChange($event)" class="my-carousel-width-auto" [config]="carouselOptions">
        <ng-container *ngFor="let list of allBottomProducts.data; let i = index">
          <common-product-card-view [list]="list" *ngIf="list.outOfStockAll != 1" (view)="viewProductDetails($event)"
            [isCommunityProduct]="true" class="swiper-slide" [isUpvote]="true"></common-product-card-view>
        </ng-container>
      </app-my-carousel-swiper>
    </ng-container>
    <ng-container *ngIf="isLoading">
      <common-product-card-view-loader></common-product-card-view-loader>
    </ng-container>
    <ng-container *ngIf="selectedTab == 'popular'">
      <app-product-review [categoryName]="'Popular Services'" [subRegionName]="userRegionName"
        [productIds]="productIds"></app-product-review>
    </ng-container>
  </div>

  <div class="text-center border-0 p-4" *ngIf="allBottomProducts?.totalCount < 1 && !isLoading">
    <img src="assets/images/no-found-products.png" alt="No Products" class="img-fluid mb-4" />
    <h2 class="card-title fw-bold text-secondary">No Products Found</h2>
    <p class="card-text text-muted">It seems we couldn’t find any products matching your search. Please try adjusting
      your filters or browse our categories.</p>
  </div>
</div>